import {
  DashboardOutlined,
  TeamOutlined,
  BookOutlined,
  CalendarOutlined,
  CrownOutlined,
  ShoppingOutlined,
  GiftOutlined,
  SettingOutlined
} from '@ant-design/icons';
import type { MenuItem } from '@/types';

export const menuConfig: MenuItem[] = [
  {
    path: '/dashboard',
    name: '数据看板',
    icon: 'DashboardOutlined',
    permission: 'dashboard:read'
  },
  {
    path: '/users',
    name: '用户管理',
    icon: 'TeamOutlined',
    permission: 'user:read'
  },
  {
    path: '/teachers',
    name: '老师管理',
    icon: 'CrownOutlined',
    permission: 'teacher:read'
  },
  {
    path: '/courses',
    name: '课程管理',
    icon: 'BookOutlined',
    permission: 'course:read'
  },
  {
    path: '/bookings',
    name: '预约考勤',
    icon: 'CalendarOutlined',
    permission: 'booking:read'
  },
  {
    path: '/orders',
    name: '订单管理',
    icon: 'ShoppingOutlined',
    permission: 'order:read'
  },
  {
    path: '/products',
    name: '商品管理',
    icon: 'ShoppingOutlined',
    permission: 'product:read'
  },
  {
    path: '/events',
    name: '活动管理',
    icon: 'GiftOutlined',
    permission: 'event:read'
  },
  {
    path: '/system',
    name: '系统设置',
    icon: 'SettingOutlined',
    children: [
      {
        path: '/system/admin-users',
        name: '员工管理',
        permission: 'admin_user:read'
      },
      {
        path: '/system/roles',
        name: '角色权限',
        permission: 'role:read'
      },
      {
        path: '/system/logs',
        name: '操作日志',
        permission: 'log:read'
      }
    ]
  }
];

export const iconMap: Record<string, React.ComponentType> = {
  DashboardOutlined,
  TeamOutlined,
  CrownOutlined,
  BookOutlined,
  CalendarOutlined,
  ShoppingOutlined,
  GiftOutlined,
  SettingOutlined
};
